import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IAppealDecision,
  IAppealFileSetterParams,
  IAppealGetterParams,
  IAppealPeriodParams,
  IAppealPeriodShema,
  IAppealResolveSetterParams,
  IAppealSchema,
  IAppealSetterParams,
} from "~/entity/Appeals/model/schema";
import { paramsSerializer } from "~/shared/lib/paramsSerializer";
import { TFilterDealerGroup } from "~/shared/model/types";

const appealsServiceMap = {
  appeals: "/employee/appeal",
  report: "/employee/appeal/report",
  appealFile: "/employee/appeal/file",
  appealSend: "/employee/appeal/send",
  appealNeedInfo: "/employee/appeal/needInfo",
  appealReview: "/employee/appeal/review",
  appealClose: "/employee/appeal/close",
  appealPeriods: "/employee/appeal-periods",
  appealDecision: "/employee/appeal/decision",

  appealContacts: "/employee/contacts/possible",
};

export class Appeals {
  static _routes = appealsServiceMap;
  static GET = {
    appealsList: (
      params: Partial<IAppealGetterParams>,
    ): NetworkResponse<IAppealSchema[]> =>
      requestREST.get(appealsServiceMap.appeals, {
        params,
        paramsSerializer: (params) =>
          paramsSerializer(params, { allowEmptyArrays: true }),
      }),

    byId: (id: string | number): NetworkResponse<IAppealSchema> =>
      requestREST.get(`${appealsServiceMap.appeals}/${id}`),

    appealContacts: (params: {
      dealerGroup: Partial<TFilterDealerGroup>;
    }): NetworkResponse<any[]> =>
      requestREST.get(appealsServiceMap.appealContacts, { params }),

    appealPeriods: (params?: {
      year: number;
      month: number;
    }): NetworkResponse<IAppealPeriodShema[]> =>
      requestREST.get(appealsServiceMap.appealPeriods, { params }),

    report: (
      params: Partial<IAppealGetterParams>,
    ): NetworkResponse<{ fileHash: string }> =>
      requestREST.get(appealsServiceMap.report, {
        params,
        paramsSerializer: (params) =>
          paramsSerializer(params, { allowEmptyArrays: true }),
      }),
  };

  static PUT = {
    set: (data: IAppealSetterParams): NetworkResponse<{ id: string }> =>
      requestREST.put(appealsServiceMap.appeals, data),

    setAppealPeriods: (data: IAppealPeriodParams): NetworkResponse<unknown> =>
      requestREST.put(appealsServiceMap.appealPeriods, data),
    appealDecision: (data: IAppealDecision): NetworkResponse<any> =>
      requestREST.put(appealsServiceMap.appealDecision, data),
  };

  static POST = {
    sent: (id: string | number): NetworkResponse<unknown> =>
      requestREST.post(appealsServiceMap.appealSend, { id }),

    needInfo: (
      id: string | number,
      comment: string,
    ): NetworkResponse<unknown> =>
      requestREST.post(appealsServiceMap.appealNeedInfo, { id, comment }),

    review: (id: string | number): NetworkResponse<unknown> =>
      requestREST.post(appealsServiceMap.appealReview, { id }),

    close: (data: IAppealResolveSetterParams): NetworkResponse<unknown> =>
      requestREST.post(appealsServiceMap.appealClose, data),

    addFile: (data: IAppealFileSetterParams): NetworkResponse<{ id: string }> =>
      requestREST.post(appealsServiceMap.appealFile, data),
  };

  static DELETE = {
    deleteFile: (data: IAppealFileSetterParams): NetworkResponse<unknown> =>
      requestREST.delete(appealsServiceMap.appealFile, { data }),
  };
}
